$(document).ready(function () {
	var searchTimeoutThrottle = 500;
	var searchTimeoutID = -1;
	var currReqObj = null;
	var $headerBox = $('.search-results-content');
	var $servicesBox = $('.service-searches-results');
	var $resultsBox;

	// var searchBoxPosition = $('.searches-wrap').offset().top;

	$('.search-inp input, .services-search input').on('keyup', function () {
		var view = $(this).data('view');
		if (!view) {
			view = 'ajax';
			$resultsBox = $headerBox;

			if ($(this).val()) {
				$('.search-wrapper .clear').addClass('d-block');
				$('.search-wrapper .search').addClass('d-none');
			} else {
				$('.search-wrapper .clear').removeClass('d-block');
				$('.search-wrapper .search').removeClass('d-none');
			}
		} else {
			$resultsBox = $servicesBox;
		}

		// Kill outstanding ajax request
		if (currReqObj != null) currReqObj.abort();
		// Kill previous search
		clearTimeout(searchTimeoutID);

		var val = $(this).val();
		if (val.length <= 0) {
			if ($resultsBox.length) {
				$resultsBox.html('');
			}
			return false;
		}

		//Search term
		var term = '*' + val + '*';

		// Do next search (in X milliseconds)
		searchTimeoutID = setTimeout(function () {
			//Ajax hit on search page
			currReqObj = $.ajax({
				url: `${window.language}/search`,
				data: {
					type: 'product',
					view,
					q: term,
				},
				success: function (data) {
					$resultsBox.html(data);
					// $('.searches-results__overlay').css({
					// 	top: searchBoxPosition,
					// });
				},
			});
		}, searchTimeoutThrottle);
	});

	$('.search-wrapper .clear').on('click', function () {
		$(this).parent().find('input').val('');
		$('.search-wrapper .clear').removeClass('d-block');
		$('.search-wrapper .search').removeClass('d-none');
		$resultsBox.html('');
	});

	$('.services-search_field').on('keyup', function (e) {
		var currentValue = $(this).val();
		$('.searches-wrap').show();
		$('.services-search').find('input').focus().val(currentValue);

		console.log(currentValue.length);

		if (currentValue.length > 0) {
			$('#filter-search').hide();
			$('#filter-clear').show();
			$('html, body').addClass('scroll-hidden');
		} else {
			$('#filter-search').show();
			$('#filter-clear').hide();
			$('html, body').removeClass('scroll-hidden');
		}
	});

	if ($(window).width() >= 992) {
		$('.js-search').on('click', (e) => {
			e.stopPropagation();
			e.preventDefault();
			$('.search-wrapper').addClass('search-wrapper--active');
			$('.mob-opacity').addClass('mob-opacity--active');
			$('.search-inp').focus();
		});

		$('body').on('click', (e) => {
			$('.search-wrapper').removeClass('search-wrapper--active');
			$('.mob-opacity').removeClass('mob-opacity--active');
		});

		$('.search-wrapper').on('click', (e) => {
			e.stopPropagation();
		});

		$('#filter-clear').on('click', function () {
			$('.services-search_field').val('');
			$('#filter-search').show();
			$('#filter-clear').hide();
			$('html, body').removeClass('scroll-hidden');
		});
	} else {
		$('#filter-clear').on('click', function () {
			$('.services-search_field').val('');
			$('#filter-search').show();
			$('#filter-clear').hide();
			$resultsBox.html('');
			$('.search-results-content--service').html('')
			$('.searches-wrap').hide();
			$('html, body').removeClass('scroll-hidden');
		});
	}
});
